/**
 * Configuration for opening the QC Reject Reason Dialog.
 */
export interface QCRejectReasonDialogConfig {
    readonly initialReason?: string | null;
}

/**
 * Result returned when the QC Reject Reason Dialog closes.
 */
export interface QCRejectReasonDialogResult {
    readonly confirmed: boolean;
    readonly reason?: string | null;
}
